import * as yup from 'yup';

export const urlSchema = yup
  .string()
  .url('Please enter a URL beginning with https:// or http:// and ending with a valid domain name.')
  .required('Please enter a URL beginning with https:// or http:// and ending with a valid domain name.');
